import * as actionTypes from '../actions/actionTypes';

const initialState={
    
    drivers: [],
    loading: false,
    registered: false //means that when this is true, the user has already filled in and submitted the driver data
}

const reducer=(state=initialState, action)=>{
    
    switch (action.type){
            
        case actionTypes.REGISTRATION_INIT:
            
            return{
                
                registered: true
            }
            
            
        case actionTypes.REGISTRATION_START:
            return{
                
                ...state,
                loading: true,
                
            }
            
        case actionTypes.REGISTRATION_SUCCESS:
            
            const newDriver={
                
                ...action.driverData
            }
            
            return {
                
               ...state,
                loading:false,
                registered: !state.registered,
                drivers: state.drivers.concat(newDriver)
            }
            
        case actionTypes.REGISTRATION_FAIL:
            return {
                
                ...state,
                loading: false
            }
            
            
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/reg.js